module.exports = __webpack_public_path__ + "static/media/android.d318d811.png";